export default __webpack_public_path__ + "static/media/torres-strait.b353b059.svg";